// extracted by mini-css-extract-plugin
export default {"base":"details-spacing_base__-BpeX","margin":"details-spacing_margin__8om10","padding":"details-spacing_padding__zTBSF"};